import { useState } from 'react';
import { RequestPaginationData } from '../../../core/interfaces/request';
import { SyncHistoryItemsFactory } from '../ActivationSyncHistory/factory';
import { SYNC_HISTORY_PAGE_SIZE } from '../constants/constants';
import ActivationsAPI from '../api/ActivationsAPI';

export const useActivationHistorySyncHistoryService = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(SyncHistoryItemsFactory(null));
  const [error, setError] = useState();

  const setInitialState = () => {
    setLoading(false);
    setError(null);
    setData(null);
  };

  const getItems = async (activationId: number, paginationData: RequestPaginationData) => {
    setInitialState();

    const params: any = {
      activation_id: activationId,
      ...paginationData,
    };

    if ('page' in params) {
      params['offset'] = params.page * SYNC_HISTORY_PAGE_SIZE;
      delete params.page;
    }

    setLoading(true);

    try {
      const res = await ActivationsAPI.getActivationSyncHistory(params);
      setLoading(false);
      setData(SyncHistoryItemsFactory(res.data));
    } catch (e) {
      setLoading(false);
      setData(null);
      setError(e);
    }
  };

  return { loading, data, error, getItems };
};
